import { combineReducers } from "redux";
import reinspection from "../features/admin/propertyinspection/reinspection/Slice";
import inspection from "../features/admin/propertyinspection/inspection/Slice";





const propertyinspection = combineReducers({
   reinspection: reinspection,
  inspection: inspection,
  });
  
  export default propertyinspection;